import { Component, EventEmitter, Input, Output } from '@angular/core';
import { User } from './users.model';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css'],
})
export class UserListComponent {
  @Input() users: ReadonlyArray<User> = [];
  @Output() add = new EventEmitter<string>();
}
